<div class="control-wrapper">
  <label class="ui-g-1" *ngIf="isRequired" [ngClass]="{ required: isRequired }"></label>
  <div class="ui-g-11">
    <p-checkbox
      appEnterClick
      [label]="label"
      [binary]="binary"
      (onChange)="selectValue($event)"
      [(ngModel)]="selectedValue"
      [disabled]="control.disabled || forceDisable"></p-checkbox>
  </div>
</div>
